import { lazy, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useCatalogDataByAlias } from 'hooks/useCatalog';
import { useSelector } from 'react-redux';
import { useGetHomeUrl } from 'hooks/useNavigation';
import { DEFAULT_HOME_URL } from 'tools/tools';
const Home = lazy(() => import('app/home'));

export default function HomeRouteWrapper(props: any) {
    const [showHomePage, setShowHomePage] = useState<boolean>(false);
    const homePageUrl = useGetHomeUrl();
    const urlParams = useParams();
    const catalogAlias = urlParams?.catalog ?? '';
    const currentCatalog = useCatalogDataByAlias(urlParams?.catalog ?? '');
    const displayDefaultCatalog = useSelector((state: any) => state.auth?.userInfo?.displayDefaultCatalog);
    const isOnCatalogRoute = !!catalogAlias;

    useEffect(() => {
        if (!isOnCatalogRoute && homePageUrl != DEFAULT_HOME_URL) {
            // On /home route with default catalog disabled  — redirect
            window.location.href = homePageUrl;
        } else if (
            catalogAlias &&
            (!currentCatalog || (currentCatalog.is_system_ind == 'Y' && !displayDefaultCatalog))
        ) {
            // Catalog not found or system catalog with default catalog disabled — redirect to homePageUrl
            window.location.href = homePageUrl;
        } else {
            setShowHomePage(true);
        }
    }, [isOnCatalogRoute, catalogAlias, currentCatalog, displayDefaultCatalog]);

    return showHomePage ? <Home {...props} /> : null;
}
